export const IN_PERSON_LOCATION = 'in_person';
export const REMOTE_LOCATION = 'remote';